import Vue from 'vue';
import StoreCategories from '@/plugins/graphql/queries/v2/store_manager/store-categories.gql';
import { StoreCategoryModel } from '@/helpers/entities/models/StoreCategoryModel';
export default Vue.extend({
    apollo: {
        storeCategories: {
            query: StoreCategories,
            update({ storeCategories }) {
                return storeCategories.edges.map((sc) => {
                    return new StoreCategoryModel(sc.node);
                });
            },
        },
    },
    data() {
        return {
            storeCategories: null,
        };
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                storeCategories: this.storeCategories,
            });
        }
    },
});
